<dx-popup
    #addAPAdjustmentPopup
    width="80%"
    height="80%"
    [title]="adjustmentTitle"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onShown()"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'content'" #addAPAdjustmentEditorPopup>
        <dx-box
            *ngIf="!!apAdjustmentEditor"
            width="100%"
            height="100%"
            direction="col"
            class="add-ap-adjustment-editor"
        >
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-form
                        *ngIf="!!apAdjustment"
                        width="100%"
                        height="100%"
                        [colCount]="1"
                        class="adjustment-editor-form"
                    >
                        <dxi-item itemType="group" [colCount]="3">
                            <dxi-item [isRequired]="true">
                                <dxo-label text="Adjustment Type"></dxo-label>
                                <div *dxTemplate>
                                    <dx-select-box
                                        displayExpr="displayText"
                                        valueExpr="key"
                                        [dataSource]="apAdjustmentEditor.adjustmentTypes"
                                        [(value)]="apAdjustment.debitOrCredit"
                                        [readOnly]="!apAdjustmentEditor.allowEdit || disabledAdjustmentType"
                                    ></dx-select-box>
                                </div>
                            </dxi-item>
                            <dxi-item [colSpan]="2" [isRequired]="true">
                                <dxo-label text="Vendor"></dxo-label>
                                <div *dxTemplate>
                                    <div class="row-container">
                                        <div class="row-content">
                                            <app-multi-column-selector
                                                #vendorSelector
                                                [name]="'Vendor'"
                                                [gridSource]="apAdjustmentEditor.vendorList"
                                                [boxValue]="vendorGridBoxValue"
                                                [dropDownButtonTemplate]="'dropDownButton'"
                                                [dropDownOptions]="{ width: 700 }"
                                                [valueExpr]="'id'"
                                                [displayExpr]="'name'"
                                                [columnDef]="vendorColumns"
                                                [showClearButton]="true"
                                                [readOnly]="!apAdjustmentEditor.allowEdit"
                                                [placeholder]="'Search Vendor...'"
                                                (gridSelectionEvent)="onVendorPayeeSelection($event)"
                                            ></app-multi-column-selector>
                                        </div>
                                        <div class="add-padding">
                                            <app-attachment-editor
                                                [viewOnly]="!isInternalUser"
                                                [communityId]="communityId"
                                                [attachments]="apAdjustmentAttachments"
                                                (onAttachmentUpdate)="onAttachmentUpdate($event)"
                                            ></app-attachment-editor>
                                        </div>
                                    </div>
                                </div>
                            </dxi-item>
                        </dxi-item>
                        <dxi-item itemType="group" [colCount]="7">
                            <dxi-item [colSpan]="2" [isRequired]="true">
                                <dxo-label text="Document Date"></dxo-label>
                                <div *dxTemplate>
                                    <dx-date-box
                                        type="date"
                                        [readOnly]="!apAdjustmentEditor.allowEdit && !isLimitedEdit"
                                        [openOnFieldClick]="true"
                                        [showClearButton]="true"
                                        [(value)]="apAdjustment.docDate"
                                    ></dx-date-box>
                                </div>
                            </dxi-item>
                            <dxi-item [colSpan]="2" [isRequired]="true">
                                <dxo-label text="Post Date"></dxo-label>
                                <div *dxTemplate>
                                    <dx-date-box
                                        type="date"
                                        [readOnly]="!apAdjustmentEditor.allowEdit"
                                        [openOnFieldClick]="true"
                                        [showClearButton]="true"
                                        [(value)]="apAdjustment.postDate"
                                    ></dx-date-box>
                                </div>
                            </dxi-item>
                            <dxi-item [colSpan]="3" [isRequired]="true">
                                <dxo-label text="Description"></dxo-label>
                                <div *dxTemplate>
                                    <dx-text-box [(value)]="apAdjustment.description"></dx-text-box>
                                </div>
                            </dxi-item>
                        </dxi-item>
                        <dxi-item itemType="group" [colCount]="5" [visible]="isEditMode">
                            <dxi-item>
                                <dxo-label text="Charge"></dxo-label>
                                <div *dxTemplate>
                                    {{ apAdjustment.amount | ccCurrency }}
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <dxo-label text="Charge Due"></dxo-label>
                                <div *dxTemplate>
                                    {{ apAdjustment.openBalance | ccCurrency }}
                                </div>
                            </dxi-item>
                            <dxi-item [colSpan]="3" itemType="empty"></dxi-item>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto" *ngIf="isInternalUser && apAdjustmentEditor.allowEdit">
                <div *dxTemplate class="toolbar-container">
                    <dx-toolbar>
                        <dxi-item
                            location="after"
                            widget="dxButton"
                            [options]="{
                                type: 'default',
                                template: 'multiIconTemplate',
                                text: addLineItemButtonOptions,
                                onClick: onNewLineItemClick
                            }"
                        ></dxi-item>

                        <app-multi-icon-button-template templateName="multiIconTemplate">
                            <app-security-info
                                iconColor="cc-white-icon"
                                securityIndicator="SHIELD"
                                apiAction="POST"
                                apiUrl="api/cb/ap/adjustment"
                            ></app-security-info>
                        </app-multi-icon-button-template>
                    </dx-toolbar>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-data-grid
                        #apAdjustmentEditorGrid
                        *ngIf="!!apAdjustment"
                        ccAddNewRow
                        height="95%"
                        keyExpr="itemId"
                        class="cc-vertical-center-cell-data-grid"
                        [highlightChanges]="true"
                        [repaintChangesOnly]="true"
                        [dataSource]="apAdjustment.items"
                        [allowColumnReordering]="true"
                        [allowColumnResizing]="true"
                        [columnAutoWidth]="true"
                        [showBorders]="true"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        (onRowUpdated)="onRowUpdated($event)"
                        (onContentReady)="onEditorContentReady($event)"
                        (onAddNewRow)="onNewLineItemClick()"
                        (onCellPrepared)="onCellPrepared($event)"
                    >
                        <dxo-editing
                            mode="cell"
                            [selectTextOnEditStart]="true"
                            [allowUpdating]="true"
                            [useIcons]="true"
                        ></dxo-editing>
                        <dxo-load-panel [enabled]="false"></dxo-load-panel>
                        <dxo-pager [visible]="false"></dxo-pager>
                        <dxo-paging [enabled]="false"></dxo-paging>

                        <dxi-column
                            *ngIf="isInternalUser"
                            caption="Action"
                            alignment="center"
                            cellTemplate="deleteCellTemplate"
                            headerCellTemplate="actionHeaderCellTemplate"
                            width="70"
                        ></dxi-column>

                        <dxi-column
                            dataType="number"
                            caption="Item #"
                            width="70"
                            cellTemplate="itemNumber"
                            [allowEditing]="false"
                        ></dxi-column>

                        <dxi-column
                            caption="Account"
                            dataField="selectedAccountName"
                            dataType="string"
                            width="220"
                            headerCellTemplate="mandatoryCellTemplate"
                            editCellTemplate="accountEditCellTemplate"
                            [showEditorAlways]="apAdjustmentEditor.allowEdit"
                            [allowEditing]="apAdjustmentEditor.allowEdit"
                        ></dxi-column>

                        <ng-container *ngIf="apAdjustmentEditor?.entityUsesSubCategory">
                            <dxi-column
                                dataField="subCategory"
                                dataType="string"
                                caption="Sub Category"
                                width="200"
                                [allowSorting]="false"
                                editCellTemplate="subCategoryTemplate"
                                [showEditorAlways]="apAdjustmentEditor.allowEdit"
                                [allowEditing]="apAdjustmentEditor.allowEdit"
                            ></dxi-column>
                        </ng-container>

                        <dxi-column
                            dataField="amount"
                            dataType="number"
                            caption="Amount"
                            width="110"
                            headerCellTemplate="mandatoryCellTemplate"
                            [format]="currencyFormat"
                            [showEditorAlways]="apAdjustmentEditor.allowEdit"
                            [allowEditing]="apAdjustmentEditor.allowEdit"
                            [editorOptions]="{ format: '$ #,##0.00' }"
                        ></dxi-column>

                        <dxi-column
                            dataField="openBalance"
                            dataType="number"
                            width="130"
                            caption="Open Balance"
                            [format]="currencyFormat"
                            [allowEditing]="false"
                            [editorOptions]="{ format: '$ #,##0.00' }"
                        ></dxi-column>

                        <ng-container *ngIf="dimensionSource.length > 0">
                            <ng-container *ngFor="let col of dimensionSource">
                                <dxi-column
                                    dataType="string"
                                    headerCellTemplate="requiredDimensionColumnHeaderTemplate"
                                    [dataField]="col.code"
                                    [caption]="col"
                                    [allowSorting]="false"
                                    [showEditorAlways]="allowChangeRequiredDimension && apAdjustmentEditor.allowEdit"
                                    [allowEditing]="allowChangeRequiredDimension && apAdjustmentEditor.allowEdit"
                                >
                                    <dxo-lookup
                                        displayExpr="text"
                                        valueExpr="code"
                                        [allowClearing]="true"
                                        [dataSource]="col.options"
                                    ></dxo-lookup>
                                </dxi-column>
                            </ng-container>
                        </ng-container>

                        <dxi-column
                            dataField="description"
                            dataType="string"
                            caption="Description"
                            [showEditorAlways]="true"
                            [allowEditing]="true"
                            [editorOptions]="{ showClearButton: true }"
                        ></dxi-column>

                        <div *dxTemplate="let header of 'actionHeaderCellTemplate'">
                            {{ header.column.caption }}
                            <app-security-info
                                securityIndicator="SHIELD"
                                apiAction="PUT"
                                apiUrl="api/cb/ap/adjustment"
                            ></app-security-info>
                        </div>

                        <div *dxTemplate="let header of 'mandatoryCellTemplate'">
                            {{ header.column.caption }}
                            <sup class="cc-text-required">*</sup>
                        </div>

                        <div *dxTemplate="let header of 'requiredDimensionColumnHeaderTemplate'">
                            {{ header.column.caption.text }}
                            <sup *ngIf="header.column.caption.required" class="cc-text-required">*</sup>
                        </div>

                        <div *dxTemplate="let cellInfo of 'subCategoryTemplate'">
                            <dx-select-box
                                displayExpr="title"
                                valueExpr="code"
                                [searchEnabled]="true"
                                [disabled]="cellInfo.data.disableSubCategory || !!isLimitedEdit"
                                [dataSource]="cellInfo.data.subCategorySource"
                                [(value)]="cellInfo.data.subCategoryCode"
                            ></dx-select-box>
                        </div>

                        <div *dxTemplate="let d of 'deleteCellTemplate'">
                            <dx-button
                                type="danger"
                                stylingMode="text"
                                [icon]="iconDelete"
                                [disabled]="!!isLimitedEdit || apAdjustment.items.length === 1"
                                (onClick)="onDeleteFromGrid(d.data)"
                            ></dx-button>
                        </div>

                        <div *dxTemplate="let item of 'itemNumber'">
                            <span>
                                {{ item.row.rowIndex + 1 }}
                            </span>
                        </div>

                        <div *dxTemplate="let cellInfo of 'accountEditCellTemplate'">
                            <app-account-selector
                                [accountTypeSource]="accountTypeSource"
                                [glAccountLabelSource]="glAccountLabelSource"
                                [glAccounts]="glAccountNumberSource"
                                [defaultOffsetGLAccountNumber]="defaultOffsetGLAccountNumber"
                                [selectedAccountType]="cellInfo.data.accountType"
                                [selectedAccountLabel]="cellInfo.data.accountLabelCode"
                                [selectedGLAccountNumber]="cellInfo.data.glAccountNumber"
                                [selectedOffsetAccount]="cellInfo.data.offsetGLAccountNumber"
                                [value]="cellInfo.value"
                                [cellInfo]="cellInfo"
                                (onSelection)="onAccountSelection($event, cellInfo)"
                            ></app-account-selector>
                        </div>
                        <dxo-summary [recalculateWhileEditing]="true">
                            <dxi-total-item
                                name="amount"
                                column="amount"
                                showInColumn="amount"
                                summaryType="sum"
                                dataType="number"
                                displayFormat="Total: {0}"
                                [valueFormat]="currencyFormat"
                            ></dxi-total-item>
                        </dxo-summary>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="button-container">
                        <div class="left-content">
                            <dx-button
                                type="default"
                                text="Cancel"
                                [icon]="iconCancel"
                                (onClick)="onCancelClick()"
                            ></dx-button>
                        </div>
                        <div class="right-content">
                            <dx-button
                                type="success"
                                text="Save"
                                [icon]="iconSave"
                                (onClick)="onSaveClick()"
                            ></dx-button>
                        </div>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#addAPAdjustmentEditorPopup' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #apAdjustmentMessageBox></cc-message-box>
